const state = {
 reload_company_payment_process_info: false,
};

const actions = {};

const mutations = {
 RELOAD_COMPANY_PAYMENT_PROCESS_INFO(state, payload) {
  state.reload_company_payment_process_info = payload.action;
 }
};

export default {
 state,
 actions,
 mutations
}
